export const BUSINESS_DATA_QUERY_KEY = "jbd";
